(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CruiseBookingPassengerMakeup',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		if (Adzuki.app !== 'Web' || Adzuki.client_id !== null) {
			Adzuki.Typeahead('#past-passenger-lookup', '/Clients/pastPassengerLookup', function select(item) {
				setPastPassengerFields(item);
			});
		}

		$('.set-passenger-city').click(function setDefaultPassengerCity(e) {
			e.preventDefault();

			Adzuki.Ajax.get('/Agents/setDefaultPassengerCity/' + $('#cruisebookingpassengermakeup-passenger_city').val())
			.then(function success(response) {
				Adzuki.StatusMessage('Success', 'Default passenger city saved.');
			});
		});

		$('.past-passenger-choice').click(function pastPassengerChanged() {
			var choice = parseFloat($(this).data("val"));

			if (choice === 1) {
				$('.past-passenger-container').removeClass('hidden');

				$('#past-passenger-lookup').prop('disabled', false);
				$('#cruisebookingpassengermakeup-client_id').prop('disabled', false);
				$('#cruisebookingpassengermakeup-firstname').prop('disabled', false);
				$('#cruisebookingpassengermakeup-lastname').prop('disabled', false);
				$('#cruisebookingpassengermakeup-gendercode').prop('disabled', false);
				$('#cruisebookingpassengermakeup-dob').prop('disabled', false);
				$('#cruisebookingpassengermakeup-dob_hidden').prop('disabled', false);
			} else {
				$('.past-passenger-container').addClass('hidden');

				$('#past-passenger-lookup').prop('disabled', true);
				$('#cruisebookingpassengermakeup-client_id').prop('disabled', true);
				$('#cruisebookingpassengermakeup-firstname').prop('disabled', true);
				$('#cruisebookingpassengermakeup-lastname').prop('disabled', true);
				$('#cruisebookingpassengermakeup-gendercode').prop('disabled', true);
				$('#cruisebookingpassengermakeup-dob').prop('disabled', true);
				$('#cruisebookingpassengermakeup-dob_hidden').prop('disabled', true);
			}
		});

		$('.reset-past-passenger').click(function resetPastPassenger(e) {
			e.preventDefault();

			$('#past-passenger-lookup').prop('disabled', false);
			$('#past-passenger-lookup').val('');
			$('#cruisebookingpassengermakeup-client_id').val('');
			$('#cruisebookingpassengermakeup-firstname').val('');
			$('#cruisebookingpassengermakeup-lastname').val('');
			$('#cruisebookingpassengermakeup-gendercode').val('');
			$('#cruisebookingpassengermakeup-dob').val('');

			$('.reset-row').addClass('hidden');
		});

		function setPastPassengerFields(pax)
		{
			$('#past-passenger-lookup').val(pax.number);

			$('#cruisebookingpassengermakeup-client_id').val(pax.id);

			if (pax.first_name === undefined || pax.first_name === '') {
				$('#cruisebookingpassengermakeup-firstname').val('');
			} else {
				$('#cruisebookingpassengermakeup-firstname').val(pax.first_name);
			}

			if (pax.last_name === undefined || pax.first_name === '') {
				$('#cruisebookingpassengermakeup-lastname').val('');
			} else {
				$('#cruisebookingpassengermakeup-lastname').val(pax.last_name);
			}

			if (pax.gender === undefined || pax.gender === '') {
				$('#cruisebookingpassengermakeup-gendercode').val('');
			} else {
				$('#cruisebookingpassengermakeup-gendercode').val(pax.gender);
			}

			if (pax.dob !== undefined && pax.dob !== '0000-00-00' && pax.dob !== null) {
				$('#cruisebookingpassengermakeup-dob').data('DateTimePicker').date(pax.dob);
			} else {
				$('#cruisebookingpassengermakeup-dob').data('DateTimePicker').date(null);
			}

			$('.reset-row').removeClass('hidden');
			$('#cruisebookingpassengermakeup-dob').trigger('focus');
			$('#cruisebookingpassengermakeup-dob').trigger('blur');
		}

		initChildrenAges();
	};


	/**
	 * Initializes hidden field for children's age
	 */
	function initChildrenAges() {
		$('#cruisebookingpassengermakeup-children').change(function handleChildrenAgeFields(e) {
			$('.child_age_field').addClass('hidden');
			if ($(this).val() > 0) {
				for (let count = 1; count <= $(this).val(); count++) {
					$('#child_age_field-' + count).removeClass('hidden');
				}
			}
		});
	}
}(jQuery, window.Adzuki || {}));
